import React, { useEffect, useState } from "react";
import axios from "axios";
import ExternalLink from "../links/externalLink/ExternalLink";
import "./GeneralInformation.css";
import { apiUrl } from "../../constants";
import SpecsheetButtonWhite from "../button/specsheetButtonWhite/SpecsheetButtonWhite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { TrackGoogleAnalyticsEvent } from "../../helpers/InitializeGoogleAnalytics";
import createGoogleAnalyticsTemplateName from "../../helpers/createGoogleAnalyticsTemplateName";

function GeneralInformation({ name }) {
  const [importantNotes, setImportantNotes] = useState({});
  const [heavyAd, setHeavyAd] = useState([]);
  const [ideas, setIdeas] = useState({});
  const [testing, setTesting] = useState({});
  const [helpfulLinks, setHelpfulLinks] = useState([]);

  const [sidebarImportantNotes, setSidebarImportantNotes] = useState(false);
  const [sidebarTesting, setSidebarTesting] = useState(false);
  const [sidebarHeavyAd, setSidebarHeavyAd] = useState(false);
  const [overlayActive, setOverlayActive] = useState(false);

  // Here we get the general information at the bottom of each specsheet and set the data
  useEffect(() => {
    async function getData() {
      try {
        const { data } = await axios.get(`${apiUrl}/api/specsheets/general`);
        setImportantNotes(data[0].importantNotes);
        setHeavyAd(data[0].heavyAd);
        setIdeas(data[0].heavyAd.ideas);
        setTesting(data[0].testing);
        setHelpfulLinks(data[0].helpfullLinks);
      } catch (e) {
        console.error(e);
      }
    }
    getData();
  }, []);

  // Here we show the sidebar for the important notes and the google analytics tracking
  const showSidebarImportantNotes = () => {
    if (!sidebarImportantNotes) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Impo: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarImportantNotes(!sidebarImportantNotes);
  };

  // Here we show the sidebar for the heavy ad information and the google analytics tracking
  const showSidebarHeavyAd = () => {
    if (!sidebarHeavyAd) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Heav: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarHeavyAd(!sidebarHeavyAd);
  };

  // Here we show the sidebar for the testing information and the google analytics tracking
  const showSidebarTesting = () => {
    if (!sidebarTesting) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Test: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarTesting(!sidebarTesting);
  };

  const resetOverlay = () => {
    setOverlayActive(false);
    setSidebarTesting(false);
    setSidebarImportantNotes(false);
    setSidebarHeavyAd(false);
  };

  const showHeavyAdTop = () => {
    const item = document.getElementsByClassName("heavy-ad-top-wrapper")[0];
    const button = document.getElementsByClassName("arrow-top")[0];
    item.classList.toggle("passive");
    button.classList.toggle("passive");
  };

  const showHeavyAdBottom = () => {
    const item = document.getElementsByClassName("heavy-ad-bottom-wrapper")[0];
    const button = document.getElementsByClassName("arrow-bottom")[0];
    item.classList.toggle("active");
    button.classList.toggle("passive");
  };

  // Here we destructure the data (and sometimes rename) in order to avoid a lot of repetition in the code
  const { title, general } = importantNotes;
  const {
    title: heavyAdTitle,
    subtitle,
    general0,
    rules,
    general1,
  } = heavyAd;

  const {
    title: heavyAdIdeasTitle,
    general0: heavyAdIdeaGeneral0,
    general1: heavyAdIdeaGeneral1,
    checkList,
  } = ideas;

  const { title: testingTitle, general: testingGeneral } = testing;

  // Here we set the google analytics tracking
  function registerGoogleAnalyticsClickHelpfulLinks(linkNumber) {
    TrackGoogleAnalyticsEvent(
      "click",
      `CTA ${linkNumber}: ${createGoogleAnalyticsTemplateName(name)}`,
      "click"
    );
  }

  return (
    <div className="general-template-information-container">
      <p className="global-information-title">GENERAL TEMPLATE INFORMATION</p>

      <div className="general-information-button-container">
        <SpecsheetButtonWhite
          type="button"
          handleClick={showSidebarImportantNotes}
        >
          Important notes
        </SpecsheetButtonWhite>
        <SpecsheetButtonWhite type="button" handleClick={showSidebarHeavyAd}>
          Heavy-ad-Intervention information
        </SpecsheetButtonWhite>

        <SpecsheetButtonWhite type="button" handleClick={showSidebarTesting}>
          Testing and Delivering your Ads
        </SpecsheetButtonWhite>
      </div>

      <div
        className={
          sidebarImportantNotes
            ? "important-notes-slider__active"
            : "important-notes-slider"
        }
      >
        <div className="important-notes-container">
          <div className="container-title-important-notes">
            {title && (
              <p className="important-notes-title">{title.toUpperCase()}</p>
            )}
            <FontAwesomeIcon
              className="close-icon"
              icon={faXmark}
              onClick={showSidebarImportantNotes}
            />
          </div>

          <div className="important-notes-inner-container">
            {general?.map((sentence, index) => {
              return (
                <div key={index} className="sentence-wrapper">
                  <p>{index + 1}.</p>
                  <p>
                    {sentence.item}{" "}
                    <span>
                      <ExternalLink key={sentence.link} link={sentence.link}>
                        {sentence.link.split("https://")}
                      </ExternalLink>
                    </span>
                    <span
                      className="email-link"
                      onClick={() =>
                        (window.location = "mailto:support@adways.com")
                      }
                    >
                      {sentence.email + "."}
                    </span>
                    <br />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div
        className={
          sidebarHeavyAd ? "heavy-ad-slider__active" : "heavy-ad-slider"
        }
      >
        <div className="heavy-ad-container">
          <div className="container-title-heavy-ad">
            {heavyAdTitle && (
              <p className="heavy-ad-title">{heavyAdTitle.toUpperCase()}</p>
            )}
            <FontAwesomeIcon
              className="close-icon"
              icon={faXmark}
              onClick={showSidebarHeavyAd}
            />
          </div>

          <div>
            {subtitle && (
              <div className="heavy-ad-subtitle-wrapper">
                <p className="heavy-ad-subtitle">{subtitle.toUpperCase()}</p>

                <FontAwesomeIcon
                  className="arrow-top"
                  icon={faChevronDown}
                  onClick={showHeavyAdTop}
                />
              </div>
            )}
          </div>

          <div className={"heavy-ad-top-wrapper"}>
            {general0?.split("\n\n").map((sentence, index) => {
              return (
                <p key={index}>
                  {sentence}
                  <br />
                </p>
              );
            })}

            <ul>
              {rules?.split("\n\n").map((sentence, index) => {
                return <li key={index}>{sentence}</li>;
              })}
            </ul>

            <div>
              {general1?.split("\n\n").map((sentence, index) => {
                return (
                  <p key={index}>
                    {sentence}
                    <br />
                  </p>
                );
              })}
            </div>
          </div>

          {heavyAdIdeasTitle && (
            <div className="heavy-ad-subtitle-wrapper">
              <p className="heavy-ad-subtitle">
                {heavyAdIdeasTitle.toUpperCase()}
              </p>

              <FontAwesomeIcon
                className="arrow-bottom"
                icon={faChevronDown}
                onClick={showHeavyAdBottom}
              />
            </div>
          )}

          <div className={"heavy-ad-bottom-wrapper"}>
            {heavyAdIdeaGeneral0 && <p>{heavyAdIdeaGeneral0}</p>}

            <ul>
              {checkList?.split("\n\n").map((sentence, index) => {
                return <li key={index}>{sentence}</li>;
              })}
            </ul>

            {heavyAdIdeaGeneral1?.split("\n\n").map((sentence, index) => {
              return <p key={index}>{sentence}</p>;
            })}
          </div>
        </div>
      </div>

      <div
        className={sidebarTesting ? "testing-slider__active" : "testing-slider"}
      >
        <div className="testing-container">
          <div className="container-title-testing">
            {testingTitle && (
              <p className="testing-title">{testingTitle.toUpperCase()}</p>
            )}
            <FontAwesomeIcon
              className="close-icon"
              icon={faXmark}
              onClick={showSidebarTesting}
            />
          </div>

          <div className="testing-inner-container">
            {testingGeneral?.split("\n\n").map((sentence, index) => {
              return (
                <div key={index} className="sentence-wrapper">
                  <p>{index + 1}.</p>
                  <p>
                    {sentence}
                    <br />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="helpful-links-container">
        <div className="helpful-links-inner-container-left">
          <p className="title">HELPFUL LINKS</p>
        </div>
        <div className="links-box">
          {helpfulLinks?.map((helpfulLink, index) => {
            return (
              <div key={helpfulLink.link} className="links-wrapper">
                <p>{index + 1}.</p>
                <ExternalLink
                  key={helpfulLink.link}
                  link={helpfulLink.link}
                  clickHandler={() =>
                    registerGoogleAnalyticsClickHelpfulLinks(`HL${index + 1}`)
                  }
                >
                  {helpfulLink.title}
                </ExternalLink>
              </div>
            );
          })}
        </div>

        <div className="vertical-divider-general-info"></div>
      </div>
      <div
        className={
          overlayActive ? "overlay-general-visible" : "overlay-general"
        }
        onClick={resetOverlay}
      ></div>
    </div>
  );
}

export default GeneralInformation;
